import React from "react";
import { Gift, Package, Swords, Crown, Users, MessageSquare, FileText, Twitter, Instagram, Archive } from "lucide-react";

const RailBtn = ({ Icon, label, active, badge, onClick, testid }) => (
  <button
    data-testid={testid}
    onClick={onClick}
    title={label}
    className={`group relative flex h-12 w-12 items-center justify-center rounded-2xl transition-all duration-200
      ${active
        ? "bg-[var(--uc-primary)] text-white shadow-lg shadow-purple-900/40"
        : "text-[var(--uc-muted)] hover:text-white hover:bg-white/5"}`}
  >
    {active && <span className="absolute -left-2 top-1/2 -translate-y-1/2 h-6 w-1 rounded-full bg-[var(--uc-primary)]" />}
    <Icon className="h-[22px] w-[22px]" />
    {badge && (
      <span className="absolute -top-1 -right-1 rounded-full bg-[var(--uc-green)] px-1 text-[8px] font-black uppercase text-black">
        {badge}
      </span>
    )}
    <span className="pointer-events-none absolute left-14 z-50 whitespace-nowrap rounded-lg bg-[#0B0912] px-2.5 py-1 text-xs font-semibold text-white opacity-0 shadow-xl transition-opacity group-hover:opacity-100 border border-white/10">
      {label}
    </span>
  </button>
);

export default function LeftRail({ tab, setTab, onDailyCase, onVip, onAffiliates, onToggleChat, onProvablyFair }) {
  return (
    <aside
      data-testid="left-rail-navigation"
      className="fixed left-0 top-0 bottom-0 z-40 hidden w-[72px] flex-col items-center justify-between border-r border-[var(--uc-border)] bg-[var(--uc-rail)] py-4 lg:flex"
    >
      <div className="flex flex-col items-center gap-1.5">
        <RailBtn testid="rail-daily-case" Icon={Gift} label="Daily Case" badge="DAILY" onClick={onDailyCase} />
        <div className="my-1 h-px w-7 bg-white/10" />
        <RailBtn testid="rail-cases" Icon={Package} label="Cases" active={tab === "cases"} onClick={() => setTab("cases")} />
        <RailBtn testid="rail-battles" Icon={Swords} label="Battles" active={tab === "battles"} onClick={() => setTab("battles")} />
        <RailBtn testid="rail-inventory" Icon={Archive} label="Inventory" active={tab === "inventory"} onClick={() => setTab("inventory")} />
        <RailBtn testid="rail-affiliates" Icon={Users} label="Affiliates" onClick={onAffiliates} />
        <RailBtn testid="rail-vip" Icon={Crown} label="VIP Members" onClick={onVip} />
      </div>

      <div className="flex flex-col items-center gap-1.5">
        <RailBtn testid="rail-chat" Icon={MessageSquare} label="Toggle Chat" onClick={onToggleChat} />
        <RailBtn testid="rail-fair" Icon={FileText} label="Provably Fair" onClick={onProvablyFair} />
        <div className="my-1 h-px w-7 bg-white/10" />
        <a href="https://twitter.com" target="_blank" rel="noreferrer" className="flex h-9 w-9 items-center justify-center rounded-xl text-[var(--uc-muted)] hover:text-white hover:bg-white/5 transition-colors">
          <Twitter className="h-4 w-4" />
        </a>
        <a href="https://instagram.com" target="_blank" rel="noreferrer" className="flex h-9 w-9 items-center justify-center rounded-xl text-[var(--uc-muted)] hover:text-white hover:bg-white/5 transition-colors">
          <Instagram className="h-4 w-4" />
        </a>
      </div>
    </aside>
  );
}
